module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "ch1"
    }
  }), _c('img', {
    staticClass: "vertical",
    attrs: {
      "alt": "Starters",
      "src": "images/f0012-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("Light bites or small dishes to tantalize your taste buds, that’s what starters are all about. More often than not they set a tone, showing your guests what culinary delights await and giving diners a little taste of what’s in store. Starters also make a fantastic meal for one or two—see my Little Socca Cakes with Ratatouille "), _c('a', {
    attrs: {
      "href": "#/xhtml/16chapter10#pg33lev1"
    }
  }, [_vm._v("(page 33)")]), _vm._v(" or my Hot Butter and Soy Sauce Mackerel with Chopped Salad "), _c('a', {
    attrs: {
      "href": "#/xhtml/20chapter14#pg41lev1"
    }
  }, [_vm._v("(page 41)")]), _vm._v(". I often opt for a selection of starters rather than one main course when I eat out. I’m never happy with just one plate of food; I like to try lots of different things—and with small dishes I can leave the restaurant without feeling like I need a forklift to take me home. Since I began developing recipes for a living, I often also find myself having a starter as a lunch or light dinner, and sometimes even for breakfast . . . or perhaps that’s just my Asian heritage coming to light.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("Starters aren’t just reserved for special occasions. In Europe it is perfectly normal, and totally sensible, in my mind, to kick off a home meal—guests or no guests, midweek or brunch—with a little appetite whetter; it’s a great way of prolonging time spent at the table too. When I cooked for a French family, I discovered that a starter can simply be a slice of perfectly ripe melon with a few ribbons of salty, sweet Bayonne ham. For some other easy, quick starters, see my Poached Fennel with Pink Prawns and Toasted Almonds "), _c('a', {
    attrs: {
      "href": "#/xhtml/19chapter13#pg38lev1"
    }
  }, [_vm._v("(page 38)")]), _vm._v(", Pan Con Tomate "), _c('a', {
    attrs: {
      "href": "#/xhtml/13chapter07#pg25lev2"
    }
  }, [_vm._v("(page 25)")]), _vm._v(", or the rather unusual Morcilla, Egg, and Crisps "), _c('a', {
    attrs: {
      "href": "#/xhtml/12chapter06#pg25lev1"
    }
  }, [_vm._v("(page 25)")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("I don’t believe you need to serve something complex in order to wow your guests, but if you’re looking to push the boat out then some of my favorites are my ultra-bling Smörgåstårta "), _c('a', {
    attrs: {
      "href": "#/xhtml/26chapter20#pg57lev1"
    }
  }, [_vm._v("(page 57)")]), _vm._v(" or my dainty Baked Goat’s Cheese Cigars with Melon, Radish, and Cucumber Slaw "), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter04#pg21lev1"
    }
  }, [_vm._v("(page 21)")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("And if you’re new to the kitchen, or have a tendency to burn your food, I even have a recipe for you too: my Burnt Leek Parcels with Romesco Sauce "), _c('a', {
    attrs: {
      "href": "#/xhtml/17chapter11#pg34lev1"
    }
  }, [_vm._v("(page 34)")]), _vm._v(". It’s one of those few recipes in which burning your food is not so much undesirable as a sought-after outcome.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5eb157a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07-chapter01.vue
// module id = 75
// module chunks = 0